import React from "react";

import { componentNanoid } from "../../utils/componentNanoid";
import formatSearchResults from "../SearchContents/formatSearchResults";
import { composeCards } from "./composeCards";
import { useSearchResults } from "../../context/DataContext";

import Card from "./Card";
import { ResultColumn } from "../SearchContents/SearchResults";

import styles from "./SearchResultCardList.module.css";

export type SearchResultCardListProps = {
    itemDefs: ResultColumn[];
};

export const SearchResultCardList = ({
    itemDefs,
}: SearchResultCardListProps) => {
    const { results, resultsSummary: summary } = useSearchResults();
    const rawItems = formatSearchResults(results, itemDefs);
    const items = composeCards(itemDefs, rawItems);
    const maybeCards = items.length ? (
        <ol start={summary.currStart} className={styles.resultsCards}>
            {items.map((parts) => (
                <Card parts={parts} key={`card-${componentNanoid()}`} />
            ))}
        </ol>
    ) : null;
    return maybeCards;
};

export default SearchResultCardList;
